export const TAB_BOX = [
  {
    img: require('@/assets/image/tabbox/icon1.png'),
    label: '代理记账',
  },
  {
    img: require('@/assets/image/tabbox/icon2.png'),
    label: '注册公司',
  },
  {
    img: require('@/assets/image/tabbox/icon3.png'),
    label: '税务代办',
  },
  {
    img: require('@/assets/image/tabbox/icon4.png'),
    label: '资质办理',
  },
  {
    img: require('@/assets/image/tabbox/icon5.png'),
    label: '商标注册',
  },
  {
    img: require('@/assets/image/tabbox/icon6.png'),
    label: '法律顾问',
  },
  {
    img: require('@/assets/image/tabbox/icon7.png'),
    label: '知识产权',
  },
  {
    img: require('@/assets/image/tabbox/icon-more.png'),
    label: '更多',
    path: '/category-list',
  },
]

export const CATEGORY = [
  {
    title: '爆品课程',
    img: require('@/assets/image/icon/go.png'),
    img2: require('@/assets/image/temp-img/home1.png'),
    path: '/video-list',
    query: {},
  },
  {
    title: '优质资源',
    img: require('@/assets/image/icon/go.png'),
    img2: require('@/assets/image/temp-img/home2.png'),
    path: '/resource-list',
    query: {},
  },
  {
    title: '热门话题',
    img: require('@/assets/image/icon/go.png'),
    img2: require('@/assets/image/temp-img/home3.png'),
    path: '/popular-articles',
    query: { pageType: 2 },
  },
  {
    title: '热榜资讯',
    img: require('@/assets/image/icon/go.png'),
    img2: require('@/assets/image/temp-img/home4.png'),
    path: '/popular-articles',
    query: { pageType: 1 },
  },
]

export const TABS_SWIPE = [
  {
    title: '为你推荐',
    type: 0,
  },
  {
    title: '注册公司',
    type: 1,
  },
  {
    title: '财税服务',
    type: 2,
  },
  {
    title: '工商服务',
    type: 3,
  },
  {
    title: '商标注册',
    type: 4,
  },
  {
    title: '工商服务',
    type: 5,
  },
  {
    title: '商标注册',
    type: 6,
  },
]

export const TABS_SWIPE2 = [
  {
    title: '商品推荐',
    type: 0,
  },
  {
    title: '资讯',
    type: 1,
  },
  {
    title: '话题',
    type: 2,
  },
  {
    title: '小视频',
    type: 3,
  },
]

export const LETTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

export const CITYS = [
  {
    name: '广州',
  },
  {
    name: '深圳',
  },
  {
    name: '武汉',
  },
  {
    name: '上海',
  },
  {
    name: '郑州',
  },
]

export const CITY_LIST = [
  {
    label: 'A',
    citys: [
      {
        name: '阿拉善',
        code: 1101,
        letter: 'A',
      },
    ],
  },
  {
    label: 'G',
    citys: [
      {
        name: '广州',
        code: 1101,
        letter: 'G',
      },
    ],
  },
  {
    label: 'J',
    citys: [
      {
        name: '荆州',
        code: 1101,
        letter: 'J',
      },
    ],
  },
  {
    label: 'N',
    citys: [
      {
        name: '南宁',
      },
    ],
  },
  {
    label: 'W',
    citys: [
      {
        name: '武汉',
        code: 1101,
        letter: 'W',
      },
      {
        name: '梧州',
        code: 1101,
        letter: 'W',
      },
    ],
  },
  {
    label: 'Z',
    citys: [
      {
        name: '中山',
        code: 1101,
        letter: 'Z',
      },
      {
        name: '郑州',
        code: 1101,
        letter: 'Z',
      },
    ],
  },
]

export const CITY_LIST2 = [
  {
    text: '广州',
    children: [
      {
        text: '阿拉善',
        id: 1,
      },
      {
        text: '白云区',
        id: 2,
      },
      {
        text: '荔湾区',
        id: 3,
      },
      {
        text: '天河区',
        id: 4,
      },
      {
        text: '南沙区',
        id: 5,
      },
    ],
  },
  {
    text: '深圳',
    children: [
      {
        text: '阿拉善',
      },
      {
        text: '白云区',
      },
      {
        text: '天河区',
      },
      {
        text: '南沙区',
      },
    ],
  },
  {
    text: '梧州',
    children: [
      {
        text: '阿拉善',
      },
      {
        text: '白云区',
      },
      {
        text: '荔湾区',
      },
      {
        text: '天河区',
      },
    ],
  },
  {
    text: '武汉',
    children: [
      {
        text: '阿拉善',
      },
      {
        text: '白云区',
      },
      {
        text: '荔湾区',
      },
    ],
  },
]

export const HOT_LIST = [
  {
    title: '热搜一',
    count: '123465',
  },
  {
    title: '热搜一',
    count: '123465',
  },
  {
    title: '热搜一',
    count: '123465',
  },
  {
    title: '热搜四',
    count: '123465',
  },
]

export const CATEGORY_LIST = [
  {
    text: '精品推荐',
    children: [
      { text: '杭州', id: 1 },
      { text: '温州', id: 2 },
    ],
  },
  {
    text: '代理记账',
    children: [
      { text: '南京', id: 5 },
      { text: '无锡', id: 6 },
    ],
  },
]

export const HOT_TABS = [
  // {
  //   title: '关注',
  //   type: 1000,
  // },
  {
    title: '推荐',
    type: 1001,
  },
  {
    title: '热榜',
    type: 1002,
  },
  {
    title: '财税早报',
    type: 1003,
  },
]

export const FOLLOW_USER = [
  {
    name: '秦先生',
    avt: require('@/assets/image/temp-img/avt.png'),
  },
  {
    name: '秦先生',
    avt: require('@/assets/image/temp-img/avt.png'),
  },
  {
    name: '秦先生',
    avt: require('@/assets/image/temp-img/avt.png'),
  },
  {
    name: '秦先生',
    avt: require('@/assets/image/temp-img/avt.png'),
  },
  {
    name: '秦先生',
    avt: require('@/assets/image/temp-img/avt.png'),
  },
]

export const HOT_LIST2 = [
  {
    img: require('@/assets/image/icon/hot1.png'),
    title: '私域运营 - 为实体门店注入新的内涵（上）',
    count: 12.5,
  },
  {
    img: require('@/assets/image/icon/hot2.png'),
    title: '私域运营 - 为实体门店注入新的内涵（上）',
    count: 12.5,
  },
  {
    img: require('@/assets/image/icon/hot3.png'),
    title: '私域运营 - 为实体门店注入新的内涵（上）',
    count: 12.5,
  },
  {
    title: '私域运营 - 为实体门店注入新的内涵（上）',
    count: 12.5,
  },
]

export const ARTICLES_DETAIL_MSG = [
  {
    id: 1,
    wxName: 'QYK',
    headImgUrl: '@/assets/image/temp-img/avt.png',
    contents:
      '经营范围：智能机器系统技术服务;机器人系统技术服务;信息系统安全服...',
    createDate: '2022-04-10 17:55:22',
    likeCount: 32145,
    like: 1,
  },
  {
    id: 2,
    wxName: 'QYK',
    headImgUrl: '@/assets/image/temp-img/avt.png',
    contents:
      '经营范围：智能机器系统技术服务;机器人系统技术服务;信息系统安全服...',
    createDate: '2022-04-10 17:55:22',
    likeCount: 66666,
    like: 1,
  },
  {
    id: 3,
    wxName: 'QYK',
    headImgUrl: '@/assets/image/temp-img/avt.png',
    contents:
      '经营范围：智能机器系统技术服务;机器人系统技术服务;信息系统安全服...',
    createDate: '2022-04-10 17:55:22',
    likeCount: 64788,
    like: 2,
  },
]

export const TALK_LIST_TYPE = [
  {
    id: 1,
    title: '审计对于',
    text: '经营范围：智能即系...',
    hots: '12.5',
  },
  {
    id: 2,
    title: '审计对于',
    text: '经营范围：智能即系...',
    hots: '12.5',
  },
  {
    id: 3,
    title: '审计对于',
    text: '经营范围：智能即系...',
    hots: '12.5',
  },
]

export const TALK_LIST = [
  {
    id: 1,
    title: '#审计对于#',
    img: require('@/assets/image/temp-img/talk-img1.png'),
    text: '审计对于企业的重要性， 在于在在...',
    nice: '12.5',
    comment: 1236,
  },
  {
    id: 2,
    title: '审计对于',
    img: require('@/assets/image/temp-img/talk-img1.png'),
    text: '审计对于企业的重要性， 在于在在...审计对于企业的重要性， 在于在在...',
    nice: '12.5',
    comment: 1236,
  },
  {
    id: 3,
    title: '审计对于',
    img: require('@/assets/image/temp-img/talk-img1.png'),
    text: '审计对于企业的重要性， 在于在在...',
    nice: '12.5',
    comment: 1236,
  },
  {
    id: 4,
    title: '审计对于',
    text: '审计对于企业的重要性， 在于在在...',
    nice: '12.5',
    comment: 1236,
  },

  {
    id: 3,
    title: '审计对于',
    img: require('@/assets/image/temp-img/talk-img1.png'),
    text: '审计对于企业的重要性， 在于在在...',
    nice: '12.5',
    comment: 1236,
  },
]

export const SEARCH_TYPE_POPUP_COLUMNS = [
  {
    text: '需要资源',
    type: 2,
  },
  {
    text: '公司名称',
    type: 1,
  },
  {
    text: '提供资源',
    type: 3,
  },
]

export const SEARCH_TYPE_POPUP_COLUMNS2 = [
  {
    text: '全部',
    type: 1,
  },
  {
    text: '资金',
    type: 2,
  },
  {
    text: '资源',
    type: 3,
  },
]

export const RESOURCE_TABS = [
  {
    title: '资讯',
    type: 1,
  },
  {
    title: '话题',
    type: 2,
  },
]

export const RESOURCE_FILTER_TYPE = [
  {
    title: '地区',
    type: 0,
  },
  {
    title: '行业',
    type: 1,
  },
  {
    title: 'TA需要',
    type: 2,
  },
  {
    title: 'TA提供',
    type: 3,
  },
]

export const GROWTH_LIST_TYPE = [
  {
    title: '成长明细',
    type: 0,
  },
  {
    title: '兑换记录',
    type: 1,
  },
  {
    title: '成长规则',
    type: 2,
  },
]

export const LEVEL_ARR = [
  {
    level: 'V1',
    value: 200,
  },
  {
    level: 'V2',
    value: 400,
  },
  {
    level: 'V3',
    value: 450,
  },
  {
    level: 'V4',
    value: 500,
  },
  {
    level: 'V5',
    value: 550,
  },
  {
    level: 'V6',
    value: 600,
  },
  {
    level: 'V7',
    value: 700,
  },
  {
    level: 'V8',
    value: 1200,
  },
  {
    level: 'V9',
    value: 1400,
  },
  {
    level: 'V10',
    value: 1600,
  },
]

export const TABLE_BENEFIT_LABEL = [
  {
    label: '权益1',
  },
  {
    label: '权益2',
  },
  {
    label: '权益3',
  },
  {
    label: '权益4',
  },
  {
    label: '权益5',
  },
  {
    label: '权益6',
  },
]

export const BENEFITS = [
  {
    title: '权益1',
    type: 0,
  },
  {
    title: '权益2',
    type: 1,
  },
  {
    title: '权益3',
    type: 2,
  },
  {
    title: '权益4',
    type: 3,
  },
  {
    title: '权益5',
    type: 4,
  },
  {
    title: '权益6',
    type: 5,
  },
  {
    title: '权益7',
    type: 6,
  },
  {
    title: '权益8',
    type: 7,
  },
  {
    title: '权益9',
    type: 8,
  },
]
